import React from 'react';
import LoginActions from '../reducers/login/LoginRedux';
import {
    Sidebar,
    SidebarNav,
    Grid, Row, Col,
    Navbar,
    Nav,
    NavItem,
    NavDropdown,
  } from '@sketchpixy/rubix';
  import {
    DEFAULT_USER_IMAGE
  } from '../utils/index';
  import * as _ from 'lodash'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import axios from 'axios';

import SettingsHelpMenu from "./SettingsHelpMenu";
import MiniDocumentViewer from "./MiniDocumentViewer";
import BlueButtonRecordsViewer from './BlueButtonRecordsViewer';
import DisabilityListViewer from './DisabilityListViewer';
import packageJson from "../../package.json"
import { MoreDocsModal } from './MoreDocsModal';

class ApplicationSidebar extends React.Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            currentDbq: props.location.currentDbq ? props.location.currentDbq : JSON.parse(sessionStorage.getItem('currentDbq')),
            patient: JSON.parse(localStorage.getItem('patient')) ? JSON.parse(sessionStorage.getItem('patient')) : {},
            showMiniDoc: false,
            showDisabilityList: false,
            showBlueButtonRecords: false,
            showMoreDocs: false,
            // signatureBadge: sessionStorage.getItem("requiredSignRecords") ? JSON.parse(sessionStorage.getItem('requiredSignRecords')).length : sessionStorage.getItem('signatureBadge') ? sessionStorage.getItem('signatureBadge'): 0,
            reviewBadge: sessionStorage.getItem("correctedDbqRecords") ? JSON.parse(sessionStorage.getItem('correctedDbqRecords')).length : sessionStorage.getItem("reviewBadge") ? sessionStorage.getItem('reviewBadge') : 0
        }
    }

    componentDidMount () {
        if (window.location.pathname.includes("dashboard")) {
            this.loadCorrectedRecords();
        } 

        setInterval(
            () => {
                if (window.location.pathname.includes("corrected")) {
                    this.setState({reviewBadge: sessionStorage.getItem("correctedDbqRecords") ? JSON.parse(sessionStorage.getItem('correctedDbqRecords')).length : sessionStorage.getItem("reviewBadge") ? sessionStorage.getItem('reviewBadge') : 0})
                }
            }
         , 8000);
    }
    
    // loadRequiredSignRecords = () => {
    //     let token = localStorage.getItem('login_token');
    //     let headers = {"Content-Type": "application/json"};
    //     headers["Authorization"] = `Bearer ${token}`
    //     fetch(process.env.API_URL+"/dbq/sign", {headers})
    //     .then(response => response.json())
    //     .then(data => {
    //       sessionStorage.setItem("requiredSignRecords", JSON.stringify(data.dbqs))   
    //     //   this.setState({requiredSignRecords: data.dbqs, showSpinner: true})   
    //     //let signedDbq = localStorage.getItem('signedDbq') ? JSON.parse(localStorage.getItem('signedDbq')): '';
    //     // let signedDbqId = signedDbq && signedDbq.id ? signedDbq.id: "";
    //     // let time  = signedDbq && signedDbq.time && (new Date().getTime()-signedDbq.time)/1000 < 60 ? false : true 

    //     // let records=[]
    //     // if (data.dbqs && data.dbqs.length > 0) {
    //     //     records = _.filter(data.dbqs, function(o) { 
    //     //         return o.dbqId !== signedDbqId ? true : time
    //     //         }); 
                
    //     // }
    //     sessionStorage.setItem("signatureBadge", data.dbqs ? data.dbqs.length : 0)
    //     this.setState({signatureBadge: data.dbqs ? data.dbqs.length : 0})
    //     })
    //     .catch((error) => {
    //       console.error('Error:', error);
    //     });
    // }
    loadCorrectedRecords = () => {
        let token = localStorage.getItem('login_token');
        let headers = {"Content-Type": "application/json"};
        headers["Authorization"] = `Bearer ${token}`
        fetch(process.env.API_URL+"/patients/corrected/count", {headers})
        .then(response => response.json())
        .then(data => {    
            sessionStorage.setItem("reviewBadge", data.correctedDbqRecords ? data.correctedDbqRecords.length : 0)
            sessionStorage.setItem("correctedDbqRecords", data.correctedDbqRecords ? JSON.stringify(data.correctedDbqRecords) : null)
            this.setState({reviewBadge: data.correctedDbqRecords ? data.correctedDbqRecords.length : 0})
        })
        .catch((error) => {
            this.setState({showSpinner: false})
            console.error('Error:', error);
        });
    }
   
    actions = link => {
        const {history} = this.props
        this.props.routeChange()
        history.push(link, {"prevPath": "sidebar"})
    }
    viewMini = () => {
        this.setState({showMiniDoc: true})
    }
    viewDisabilityList = () => {
        this.setState({showDisabilityList: true})
    }
    viewBlueButtonRecords = () => {
        this.setState({showBlueButtonRecords: true})
    }
    openMoreDocsModal = () => {
        this.setState({showMoreDocs: true})
    }

    modelClose = (e) =>{
        this.setState({
            showMiniDoc: false,
        })
    }

    disabilityListModelClose = (e) =>{
        this.setState({
            showDisabilityList: false,
        })
    }

    blueButtonRecordsModelClose = (e) =>{
        this.setState({
            showBlueButtonRecords: false,
        })
    }

    closeMoreDocsModal = (e) =>{
        this.setState({
            showMoreDocs: false,
        })
    }

    render() {
        const {history} = this.props
        const {location: {pathname}} = history
        const dashboard = '/admin/dashboard';
        const confirmPatient = '/admin/confirmPatient';
        const confirmDisability = '/admin/confirmDisability';
        const exam = '/admin/exam';
        const review = '/admin/review';
        const dbq = '/admin/dbq';
        const sign = '/admin/sign';
        const check = '/admin/check';
        const corrected = '/admin/corrected';
        const signLater = '/admin/signLater';
        const compareRoute = "/admin/compare";
        const signAgainRoute = "/admin/signAgain";

        const { currentDbq, showMiniDoc, showDisabilityList, showBlueButtonRecords, showMoreDocs, patient} = this.state
        let show = window.location.pathname.includes("dashboard")
        
        return (
            <div>
                {showMiniDoc && <MiniDocumentViewer onClose={e => this.modelClose(e)} src={`${currentDbq&&currentDbq.id? currentDbq.id: ""}`} />}
                {showDisabilityList && <DisabilityListViewer onClose={e => this.disabilityListModelClose(e)} src={`${patient&&patient.id? patient.id: ""}-${currentDbq&&currentDbq.id? currentDbq.id: ""}`} />}
                {showBlueButtonRecords && <BlueButtonRecordsViewer onClose={e => this.blueButtonRecordsModelClose(e)} src={`${patient&&patient.id? patient.id: ""}-${currentDbq&&currentDbq.id? currentDbq.id: ""}`} />}
                {showMoreDocs && <MoreDocsModal onClose={e => this.closeMoreDocsModal(e)} />}
                <Grid>
                    <Row>
                        <Col xs={12} style={{paddingLeft: "5px", paddingRight: "5px"}}>
                            <div className='sidebar-nav-container'>
                                {!show && currentDbq && currentDbq.name_fv
                                ? <div style={{textAlign:'center'}}>
                                    <a className="current">
                                        <span>
                                            <img src={'/imgs/app/vbg-icons/' + currentDbq.name_fv.toLowerCase() + '.png'} width="60" height="60" alt={currentDbq.name_fv + ' image'}></img> 
                                        </span>
                                        <span className="name">{currentDbq.name_fv} DBQ</span>
                                    </a>
                                    </div>
                                : show
                                ? <div style={{height: '101px'}}></div>
                                : null}
                                
                                <SidebarNav className='notification-badges' style={{marginBottom: 0, marginTop: 0}}>

                                    <li style={pathname === dashboard ? {cursor: 'unset', background: '#c2cadd'} : {cursor: 'pointer'}} onClick={pathname === dashboard ? undefined : this.actions.bind(this, '/admin/dashboard')} className={`li-dashboard ${
                                        ( pathname === confirmPatient
                                            || pathname === confirmDisability
                                            || pathname === exam
                                            || pathname === review
                                            || pathname === dbq
                                            || pathname === sign
                                            || pathname === check
                                        ) ? 'completed' : ''} ${pathname === dashboard ? 'active-1' : ''}`}>
                                        <a 
                                        // onClick={this.actions.bind(this, dashboard)}
                                        >
                                            <span>
                                                {/* <svg width="45" height="36" viewBox="0 0 45 36" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.75 15.75C9.23203 15.75 11.25 13.732 11.25 11.25C11.25 8.76797 9.23203 6.75 6.75 6.75C4.26797 6.75 2.25 8.76797 2.25 11.25C2.25 13.732 4.26797 15.75 6.75 15.75ZM38.25 15.75C40.732 15.75 42.75 13.732 42.75 11.25C42.75 8.76797 40.732 6.75 38.25 6.75C35.768 6.75 33.75 8.76797 33.75 11.25C33.75 13.732 35.768 15.75 38.25 15.75ZM40.5 18H36C34.7625 18 33.6445 18.4992 32.8289 19.3078C35.6625 20.8617 37.6734 23.6672 38.1094 27H42.75C43.9945 27 45 25.9945 45 24.75V22.5C45 20.018 42.982 18 40.5 18ZM22.5 18C26.8523 18 30.375 14.4773 30.375 10.125C30.375 5.77266 26.8523 2.25 22.5 2.25C18.1477 2.25 14.625 5.77266 14.625 10.125C14.625 14.4773 18.1477 18 22.5 18ZM27.9 20.25H27.3164C25.8539 20.9531 24.2297 21.375 22.5 21.375C20.7703 21.375 19.1531 20.9531 17.6836 20.25H17.1C12.6281 20.25 9 23.8781 9 28.35V30.375C9 32.2383 10.5117 33.75 12.375 33.75H32.625C34.4883 33.75 36 32.2383 36 30.375V28.35C36 23.8781 32.3719 20.25 27.9 20.25ZM12.1711 19.3078C11.3555 18.4992 10.2375 18 9 18H4.5C2.01797 18 0 20.018 0 22.5V24.75C0 25.9945 1.00547 27 2.25 27H6.88359C7.32656 23.6672 9.3375 20.8617 12.1711 19.3078Z"/>
                                                </svg> */}
                                                <img src="/imgs/app/dashboard.svg" title="Complete DBQ" style={{height: 50}} />
                                            </span>
                                            <span style={{color: '#333'}}>Dashboard</span>
                                        </a>
                                    </li>

                                    {/* <li>{reviewRecords && reviewRecords.length}</li> */}

                                    <li {...(this.state.reviewBadge > 0 && { "data-badge": this.state.reviewBadge })} style={pathname === corrected ? {cursor: 'unset', background: '#c2cadd'} : {cursor: 'pointer'}} onClick={ pathname === corrected ? undefined : this.actions.bind(this, '/admin/corrected')} className={`li-dashboard ${
                                        ( pathname === check
                                        ) ? 'completed' : ''}`}>
                                       <a> 
                                            <span>
                                            <img alt="" src="/imgs/app/needs-review.svg" title="Review Required" style={{height: 40}} />
                                            </span>
                                            <span style={{color: '#333', marginTop: 3}}>Review<br/ >Required</span>
                                        </a>
                                    </li>

                                    <li onClick={this.viewMini} className="li-dashboard" style={pathname == exam? {display: 'block'}:{display: 'none'}  }>
                                         <a>
                                            <span>
                                            <svg width="45" height="45" viewBox="0 0 45 45" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.25 11.25C11.25 10.7527 11.4475 10.2758 11.7992 9.92418C12.1508 9.57254 12.6277 9.375 13.125 9.375H31.875C32.3723 9.375 32.8492 9.57254 33.2008 9.92418C33.5525 10.2758 33.75 10.7527 33.75 11.25C33.75 11.7473 33.5525 12.2242 33.2008 12.5758C32.8492 12.9275 32.3723 13.125 31.875 13.125H13.125C12.6277 13.125 12.1508 12.9275 11.7992 12.5758C11.4475 12.2242 11.25 11.7473 11.25 11.25Z" />
                                                <path d="M11.25 18.75C11.25 18.2527 11.4475 17.7758 11.7992 17.4242C12.1508 17.0725 12.6277 16.875 13.125 16.875H31.875C32.3723 16.875 32.8492 17.0725 33.2008 17.4242C33.5525 17.7758 33.75 18.2527 33.75 18.75C33.75 19.2473 33.5525 19.7242 33.2008 20.0758C32.8492 20.4275 32.3723 20.625 31.875 20.625H13.125C12.6277 20.625 12.1508 20.4275 11.7992 20.0758C11.4475 19.7242 11.25 19.2473 11.25 18.75Z" />
                                                <path d="M13.125 24.375C12.6277 24.375 12.1508 24.5725 11.7992 24.9242C11.4475 25.2758 11.25 25.7527 11.25 26.25C11.25 26.7473 11.4475 27.2242 11.7992 27.5758C12.1508 27.9275 12.6277 28.125 13.125 28.125H31.875C32.3723 28.125 32.8492 27.9275 33.2008 27.5758C33.5525 27.2242 33.75 26.7473 33.75 26.25C33.75 25.7527 33.5525 25.2758 33.2008 24.9242C32.8492 24.5725 32.3723 24.375 31.875 24.375H13.125Z" />
                                                <path d="M11.25 33.75C11.25 33.2527 11.4475 32.7758 11.7992 32.4242C12.1508 32.0725 12.6277 31.875 13.125 31.875H20.625C21.1223 31.875 21.5992 32.0725 21.9508 32.4242C22.3025 32.7758 22.5 33.2527 22.5 33.75C22.5 34.2473 22.3025 34.7242 21.9508 35.0758C21.5992 35.4275 21.1223 35.625 20.625 35.625H13.125C12.6277 35.625 12.1508 35.4275 11.7992 35.0758C11.4475 34.7242 11.25 34.2473 11.25 33.75Z" />
                                                <path fillRule="evenodd" clipRule="evenodd" d="M3.75 7.5C3.75 6.00816 4.34263 4.57742 5.39752 3.52252C6.45242 2.46763 7.88316 1.875 9.375 1.875H35.625C37.1168 1.875 38.5476 2.46763 39.6025 3.52252C40.6574 4.57742 41.25 6.00816 41.25 7.5V37.5C41.25 38.9918 40.6574 40.4226 39.6025 41.4775C38.5476 42.5324 37.1168 43.125 35.625 43.125H9.375C7.88316 43.125 6.45242 42.5324 5.39752 41.4775C4.34263 40.4226 3.75 38.9918 3.75 37.5V7.5ZM9.375 5.625H35.625C36.1223 5.625 36.5992 5.82254 36.9508 6.17417C37.3025 6.52581 37.5 7.00272 37.5 7.5V37.5C37.5 37.9973 37.3025 38.4742 36.9508 38.8258C36.5992 39.1775 36.1223 39.375 35.625 39.375H9.375C8.87772 39.375 8.40081 39.1775 8.04918 38.8258C7.69754 38.4742 7.5 37.9973 7.5 37.5V7.5C7.5 7.00272 7.69754 6.52581 8.04918 6.17417C8.40081 5.82254 8.87772 5.625 9.375 5.625Z"/>
                                            </svg>
                                            {/* <img src="/imgs/app/completedbq.svg" title="Complete DBQ" width="45" height="45" /> */}
                                            </span>
                                            <span className='name'>Mini <br />Document</span>
                                        </a>
                                    </li>
                                    <li onClick={this.viewDisabilityList} className="li-dashboard" style={pathname == exam || pathname === compareRoute || pathname === signAgainRoute? {display: 'block'}:{display: 'none'}  }>
                                         <a>
                                            <span>
                                            <img src="/imgs/app/pdf-icon.png" alt="disability list icon" width="45" height="45" />
                                            </span>
                                            <span className='name'>Disability<br />List</span>
                                        </a>
                                    </li>
                                    <li onClick={this.viewBlueButtonRecords} className="li-dashboard" style={pathname == exam || pathname === compareRoute || pathname === signAgainRoute? {display: 'block'}:{display: 'none'}  }>
                                         <a>
                                            <span>
                                            <img src="/imgs/app/pdf-icon.png" alt="blue button records icon" width="45" height="45" />
                                            </span>
                                            <span className='name'>Blue Button<br />Records</span>
                                        </a>
                                    </li>
                                    <li onClick={this.openMoreDocsModal} className="li-dashboard" style={pathname == exam || pathname === compareRoute || pathname === signAgainRoute? {display: 'block'}:{display: 'none'}  }>
                                         <a> 
                                            <span>
                                            <img src="/imgs/app/dot.svg" alt="more items" className="li-more-icon" width="45" height="45" />
                                            </span>
                                            <span className='name'>More</span>
                                        </a>
                                    </li>
                                    

                                </SidebarNav>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

ApplicationSidebar.propTypes = {
    routeChange: PropTypes.func
}

class SidebarContainer extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
          showSettingsHelp: false
        }
    }
    actions = link => {
        const {history} = this.props
        // if(window.location.href.includes('localhost') || !history.location.pathname.includes("exam")) {
            this.props.routeChange()
            history.push(link)
        // }
    }

    logoutUser = (e) => {
        // if (this.props.loginToken)

            // provide provider id when Nestor's code is available to userId
            let token = localStorage.getItem("login_token");
            let isMaster = localStorage.getItem("is_master");
            let headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            };
            let url = `${process.env.API_URL}/patients/logout`;
            axios
            .post(url, { userId: "", userEmail: localStorage.getItem("email"), userToken: token, isMaster: isMaster }, { headers })
            .then(async (response) => {
            }).catch((e) => {

            })
            this.props.logoutUser()
            sessionStorage.removeItem('questionState');
            sessionStorage.removeItem('patient');
            sessionStorage.removeItem('currentDbq');
            sessionStorage.removeItem('page');
            sessionStorage.removeItem("current")
            sessionStorage.removeItem("src")
            sessionStorage.removeItem("note")
            sessionStorage.removeItem("pDoc")
            sessionStorage.removeItem("correctedFileURL")
            sessionStorage.removeItem("signedFileURL")
            sessionStorage.removeItem("highlightedFileURL")
            sessionStorage.removeItem("signedFileName")
            sessionStorage.removeItem("correctedFileName")
            localStorage.removeItem("email")
            localStorage.removeItem("is_master")
        // else
        //     this.props.history.push('/')
    }

    showSettingsHelpMenu = (e) => {
        this.setState({showSettingsHelp: true})
    }
    helpMenuClose = (e) =>{
        this.setState({showSettingsHelp: false})
    }
    showTestPage = (e) => {
        const {history} = this.props;
        history && history.push('/admin/compatibility')
    }

    showScriptPage = (e) => {
        const {history} = this.props;
        history && history.push('/admin/script')
    }

    render() {
        const {loginToken, history, user: {me: {userInfo = {}}}} = this.props;
        if (!loginToken ||
            (history && history.location && history.location.pathname === '/terms') ||
            (history && history.location && history.location.pathname === '/privacy')
          ) {
            return null
          }
        return (
            <div id='sidebar'>
                <div id='avatar'>
                    <Grid>
                        <Row className='fg-white'>
                            <Col collapseRight style={{textAlign:'center', height: "80px"}}>
                                
                                <img
                                    src="/imgs/app/Star_RGB.svg"
                                    
                                    alt=""
                                    width="auto"
                                    height="45px"
                                    onClick={this.actions.bind(this, '/admin/dashboard')}
                                    style={{cursor: 'pointer'}}
                                     />
                            </Col>
                        </Row>
                    </Grid>
                </div>
                <span style={{display: "flex", justifyContent: "center", marginTop: "-3.5rem"}}>version {packageJson.version}</span>
                <div id='sidebar-container'>
                    {/* <Sidebar sidebar={0} style={{overflowY: 'scroll'}}> */}
                    <Sidebar sidebar={0} >
                        <ApplicationSidebar {...this.props} />
                    </Sidebar>
                </div>
                <div className="sidebar-menu">
                    <Navbar id='rubix-nav-header' className="sidebar-menu-nav">
                        <Nav>
                            <NavItem style={{width: 120, height: 100}}>
                                <div style={{textAlign:'center'}}>
                                <span>
                                    <img
                                        src={userInfo.picture && userInfo.picture.url ? userInfo.picture.url : DEFAULT_USER_IMAGE}
                                        className='profile-img-circle' alt=""/>
                                </span>
                                <div>
                                    <a
                                        style={{
                                            textDecoration: 'none',
                                            color: 'black',
                                            top: 1,
                                            fontSize: 14,
                                            lineHeight: 1,
                                            position: 'relative'
                                        }}>
                                        {userInfo.name ? userInfo.name.last : ''}
                                    </a>
                                </div>
                                </div>
                            </NavItem>
                            <NavDropdown id="" title="" style={{position:'absolute'}}>
                                {!process.env.API_URL.includes("fastvet.joshcogroup") && <NavItem className='logout' onClick={this.showScriptPage}>Script</NavItem>}                            
                                {!process.env.API_URL.includes("fastvet.joshcogroup") && <NavItem className='logout' onClick={this.showTestPage}>Verify</NavItem>}
                                <NavItem className='logout' onClick={this.actions.bind(this, '/admin/profile')}>Settings</NavItem>
                                <NavItem className='logout' onClick={this.showSettingsHelpMenu}>Help</NavItem>
                                <NavItem className='logout' href='#' onClick={this.logoutUser}>Logout</NavItem>                                
                            </NavDropdown>
                        </Nav>
                    </Navbar>
                    {this.state.showSettingsHelp && <SettingsHelpMenu onClose={e => this.helpMenuClose(e)} />}
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({login, user}) => {
    const {loginToken, error, fetching} = login;
    return {user, loginToken, error, fetching};
  };
  
  const mapDispatchToProps = dispatch => ({
    logoutUser: () => {
      dispatch(LoginActions.createLogoutSuccess());
    }
  });

SidebarContainer.propTypes = {
    routeChange: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer)
